<template>
    <div>
        <v-container class="pa-5"  >
        <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl" > Fotos</h1>
            <div class="ma-5">
            <v-row justify="center" >
                <NovaFotoDialog :acaoEditar="false" @recarregarLista="atualizarTudo" />

                <SessoesDialog class="ml-5" @recarregarLista="atualizarTudo"  />
            </v-row>
            </div>


              <v-layout row justify-center class="mt-2" v-for="sessao in sessoes" :key="sessao.id">
                    <v-flex xs10 sm10 md10  class="grey darken-4 white--text text-center">
                    <v-layout row justify-center class="ma-1 pb-7">
                        <v-flex xs12 class="pa-5">
                            <h1 class="display-3">{{sessao.descricao}}</h1>
                        </v-flex>
                        
                        <v-flex xs10 sm10 md4 lg3 class="mb-2" v-for="img in sessao.fotos" :key="img.id">
    
                            
                            <a href="#"><v-img width="" @click="apagarFoto(img)" class="rounded-lg ma-2" aspect-ratio="1.0" :src="img.imageUrl" >
                            </v-img></a>
                            
                        </v-flex>

                    
                    </v-layout>

                
                </v-flex>
                </v-layout>
        </v-container>
    </div>
</template>

<script>
    import NovaFotoDialog from './Components/NovaFotoDialog'
    import SessoesDialog from './Components/SessoesDialog'
    // storageRef
    import { refFotos, refSessoes,storageRef } from '@/firebaseConfig' 

    export default {
        components: {
            NovaFotoDialog, SessoesDialog
        },
        data(){
            return {
                // fotos: [],
                sessoes: [],
            }
        },
        async mounted(){
            await this.carregarSessoes();
            this.filtrarFotosESessoes();
        },
        methods:{
        async atualizarTudo(){
            await this.carregarSessoes();
            this.filtrarFotosESessoes();
        },
        
        async carregarSessoes(){
            this.sessoes = []
            return refSessoes.orderBy("ordem", "asc").get().then(ref => {
                return ref.forEach(async sessao => {
                    // this.sessoes.push(sessao.data())
                    let sessaoRef = {...sessao.data(), fotos: []}
                    await refFotos.where("sessao.id", "==", sessaoRef.id ).get().then(ref => {
                        return ref.forEach(foto => {
                            // this.fotos.push(foto.data());
                            sessaoRef.fotos.push(foto.data())
                        });
                    });
                    this.sessoes.push(sessaoRef);
                })
            });

        },
         filtrarFotosESessoes(){
            // sessao.fotos
            let fotos = []
            this.sessoes.forEach(sessao => {
                
                this.fotos.forEach(foto =>{
                    // foto.sessao.id == sessao.id ? true : false
                    if(foto.sessao.id == sessao.id){
                        fotos.push(foto);
                    }
                })
                
                sessao.fotos = fotos
                // console.log("fotos",fotos);
            });
            console.log("sessao atualziada",this.sessoes);
            // this.sessoes = sessoesAtualizadas
        },
        apagarFoto(item){
            if(confirm("Deseja apagar esta foto?")){
                refFotos.doc(item.id).delete().then(() =>{
                    storageRef.ref().child(item.path).delete().then(() => {
                    this.$toasted.success("Apagada com sucesso!");
                    this.atualizarTudo();
                    })
                });
            }
        }
     }
    }
</script>

<style lang="scss" scoped>

</style>